import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "menu-user",
  "use": "menu-user-usage",
  "viewBox": "0 0 16 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 20\" id=\"menu-user\"><title>menu-user</title><path d=\"M8 9.8a4.85 4.85 0 0 1-4.8-4.9A4.85 4.85 0 0 1 8 0a4.85 4.85 0 0 1 4.8 4.9A4.85 4.85 0 0 1 8 9.8m-8 7.73a8 8 0 0 1 4.4-7.33A8 8 0 0 0 8 11.43a6.64 6.64 0 0 0 3.6-1.23 7.82 7.82 0 0 1 4.4 7.19c0 3.46-16 3.46-16 .14\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/menu-user.svg
// module id = DTTz
// module chunks = 6